const LOCALES = ['common', 'nav', 'footer', 'auth', 'notifications', 'settings', 'admin', 'account', 'journey', 'chat', 'treasureChest', 'b2c', 'cmv', 'tasks', 'assignmentAnswers', 'importUsers'];

const loadLocalEnglishMessages = () => {
  const messages = {};
  LOCALES.forEach((ns) => {
    try {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      messages[ns] = require(`./en/${ns}.json`);
    } catch (e) {
      messages[ns] = {};
    }
  });
  return messages;
};

// Local pack wins on conflicts — protects against stale remote values.
const mergeWithLocalFallback = (local, remote) => {
  const merged = { ...remote };
  Object.entries(local).forEach(([ns, strings]) => {
    merged[ns] = { ...(remote[ns] || {}), ...strings };
  });
  return merged;
};

export { LOCALES, loadLocalEnglishMessages, mergeWithLocalFallback };
